module.exports = __webpack_public_path__ + "media/pick.2de2170d.mp3";